// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"497":"364ab09e","663":"be214f58","885":"f2736917","893":"27aca2d3","904":"11186abd"}[chunkId] + ".chunk.css";
};